import clsx from 'clsx'
import {KTIcon} from '../../../helpers'
import {
  HeaderUserMenu,
  HeaderSignatureNotificationsMenu,
  HeaderGeneralNotificationsMenu,
  HeaderLeadNotificationsMenu,
  /* Search, */ ThemeModeSwitcher,
} from '../../../partials'
import {Button, Offcanvas, Spinner, Badge} from 'react-bootstrap'
import {NavbarIntegrationsSection} from '../../../../app/tfi/components/header/NavbarIntegrationsSection'
import {useDisclourse} from '../../../../app/tfi/hooks/useDisclourse'
import {getNameAvatar, handleUpdateApp} from '../../../../app/tfi/helpers'
import {useState} from 'react'
import {ModalSearchMovile} from '../../../../app/tfi/components/header/ModalSearchMovile'
import {ModalAddQuickQuote} from '../../../../app/tfi/pages/oneLead/components/ModalAddQuickQuote'
import {SystemMonitorDrawer} from '../../../../app/tfi/components/SystemMonitor/SystemMonitorDrawer'
import {Tooltip} from 'react-tooltip'
import {useGetUser} from '../../../../app/tfi/store/userStore'
import {useRealtimeStore} from '../../../../app/tfi/store/realtimeStore'
// import {useLayout} from '../../core'

import {hasPermission} from '../../../../app/tfi/helpers'
import {ALL_PERMISSIONS} from '../../../../app/tfi/helpers/consts'

const itemClass = 'ms-1 ms-md-4'
const btnClass =
  'btn btn-icon btn-custom btn-icon-muted btn-active-light btn-active-color-primary w-35px h-35px'
const userAvatarClass = 'symbol-35px'
const btnIconClass = 'fs-2'

const Navbar = () => {
  const {user} = useGetUser()
  const permissions = useGetUser((s) => s.user?.permissions) || []
  const {isOpen, onClose, onOpen} = useDisclourse()
  const {isOpen: isOpenSearch, onClose: onCloseSearch, onOpen: onOpenSearch} = useDisclourse()
  const {isOpen: isOpenAddQuote, onClose: onCloseAddQuote, onOpen: onOpenAddQuote} = useDisclourse()
  const {isOpen: isOpenMonitor, onClose: onCloseMonitor, onOpen: onOpenMonitor} = useDisclourse()
  const [loading, setLoading] = useState(false)
  const signatureUnreadCount = useRealtimeStore(
    (state) => state.notificationCounters.signatureUnreadCount
  )
  const leadUnreadCount = useRealtimeStore((state) => state.notificationCounters.leadUnreadCount)
  const generalUnreadCount = useRealtimeStore(
    (state) => state.notificationCounters.generalUnreadCount
  )

  const onLoading = (bool: boolean) => {
    setLoading(bool)
  }

  if (!user) return null

  const strAvatar = getNameAvatar(user.user?.firstName + " " + user.user?.lastName )
  // const {config} = useLayout()
  return (
    <div className='app-navbar flex-shrink-0'>
      {/* <div className={clsx('app-navbar-item align-items-stretch', itemClass)}>
        <Search />
      </div> */}

      {/* <div className={clsx('app-navbar-item', itemClass)}>
        <div id='kt_activities_toggle' className={btnClass}>
          <KTIcon iconName='chart-simple' className={btnIconClass} />
        </div>
      </div> */}

      <div className={clsx('app-navbar-item', itemClass, 'd-none-search-header')}>
        <Button
          size='sm'
          className='px-2 text-center'
          variant='transparent'
          title='Search'
          onClick={onOpenSearch}
        >
          <i className='bi bi-search fs-3 m-0 p-0 text-primary' />
        </Button>
      </div>
      {hasPermission(permissions, ALL_PERMISSIONS.VIEW_POLICY) && (
        <div className={clsx('app-navbar-item', itemClass)}>
          <Button
            size='sm'
            className='px-2 text-center'
            variant='primary'
            //title='Quick Quote'
            data-tooltip-id='my-tooltip-1'
            data-tooltip-content='Quick Quote'
            onClick={onOpenAddQuote}
          >
            <i className='bi bi-file-earmark-medical fs-3 m-0 p-0' />
            Quick Quote
          </Button>
          <Tooltip id='my-tooltip-1' place='bottom' />
        </div>
      )}
      <div className={clsx('app-navbar-item', itemClass)}>
        <Button
          size='sm'
          className='px-2 text-center'
          variant='light'
          data-tooltip-id='system-monitor-tooltip'
          data-tooltip-content='System Monitor'
          onClick={onOpenMonitor}
        >
          <i className='bi bi-activity fs-3 m-0 p-0' />
        </Button>
        <Tooltip id='system-monitor-tooltip' place='bottom' />
      </div>
      <div className={clsx('app-navbar-item', itemClass)}>
        <Button
          size='sm'
          className='px-2 text-center'
          variant='light'
          title='Settings'
          onClick={onOpen}
        >
          <i className='bi bi-gear-fill fs-3 m-0 p-0' />
        </Button>
      </div>

      {/* Signature Notifications Bell */}
      <div className={clsx('app-navbar-item', itemClass)}>
        <div
          data-kt-menu-trigger="{default: 'click'}"
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
          className={clsx(btnClass, 'position-relative')}
          data-tooltip-id='signature-notifications-tooltip'
          data-tooltip-content='Signature Notifications'
        >
          <i className='bi bi-pen fs-2' />
          {signatureUnreadCount > 0 && (
            <Badge
              bg='danger'
              pill
              className='position-absolute top-0 start-100 translate-middle'
              style={{fontSize: '10px', padding: '3px 6px'}}
            >
              {signatureUnreadCount > 99 ? '99+' : signatureUnreadCount}
            </Badge>
          )}
        </div>
        <HeaderSignatureNotificationsMenu />
        <Tooltip id='signature-notifications-tooltip' place='bottom' />
      </div>

      {/* Lead Notifications */}
      <div className={clsx('app-navbar-item', itemClass)}>
        <div
          data-kt-menu-trigger="{default: 'click'}"
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
          className={clsx(btnClass, 'position-relative')}
          data-tooltip-id='lead-notifications-tooltip'
          data-tooltip-content='Lead Notifications'
        >
          <i className='bi bi-person-plus-fill fs-2' />
          {leadUnreadCount > 0 && (
            <Badge
              bg='danger'
              pill
              className='position-absolute top-0 start-100 translate-middle'
              style={{fontSize: '10px', padding: '3px 6px'}}
            >
              {leadUnreadCount > 99 ? '99+' : leadUnreadCount}
            </Badge>
          )}
        </div>
        <HeaderLeadNotificationsMenu />
        <Tooltip id='lead-notifications-tooltip' place='bottom' />
      </div>

      {/* General Notifications Bell */}
      <div className={clsx('app-navbar-item', itemClass)}>
        <div
          data-kt-menu-trigger="{default: 'click'}"
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
          className={clsx(btnClass, 'position-relative')}
          data-tooltip-id='general-notifications-tooltip'
          data-tooltip-content='General Notifications'
        >
          <KTIcon iconName='notification' className={btnIconClass} />
          {generalUnreadCount > 0 && (
            <Badge
              bg='danger'
              pill
              className='position-absolute top-0 start-100 translate-middle'
              style={{fontSize: '10px', padding: '3px 6px'}}
            >
              {generalUnreadCount > 99 ? '99+' : generalUnreadCount}
            </Badge>
          )}
        </div>
        <HeaderGeneralNotificationsMenu />
        <Tooltip id='general-notifications-tooltip' place='bottom' />
      </div>

      {/*  <div className={clsx('app-navbar-item', itemClass)}>
        <div className={clsx('position-relative', btnClass)} id='kt_drawer_chat_toggle'>
          <KTIcon iconName='message-text-2' className={btnIconClass} />
          <span className='bullet bullet-dot bg-success h-6px w-6px position-absolute translate-middle top-0 start-50 animation-blink' />
        </div>
      </div> */}

      <div className={clsx('app-navbar-item', itemClass)}>
        <ThemeModeSwitcher toggleBtnClass={clsx('btn-active-light-primary btn-custom')} />
      </div>

      <div className={clsx('app-navbar-item', itemClass)}>
        <div
          className={clsx('cursor-pointer symbol', userAvatarClass)}
          data-kt-menu-trigger="{default: 'click'}"
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
        >
          <span className='avatar' style={{textTransform: 'uppercase', fontWeight: 'bolder'}}>
            {strAvatar}
          </span>
        </div>
        <HeaderUserMenu />
      </div>

      {/* {config.app?.header?.default?.menu?.display && (
        <div className='app-navbar-item d-lg-none ms-2 me-n3' title='Show header menu'>
          <div
            className='btn btn-icon btn-active-color-primary w-35px h-35px'
            id='kt_app_header_menu_toggle'
          >
            <KTIcon iconName='text-align-left' className={btnIconClass} />
          </div>
        </div>
      )} */}

      <Offcanvas show={isOpen} onHide={onClose} placement='end'>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Settings</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className='d-flex align-items-center justify-content-between mb-4 p-2 border border-danger rounded'>
            <div>
              <small className='fw-bold text-danger'>Force Update</small>
              <div className='text-muted' style={{fontSize: '11px'}}>Update app to latest version</div>
            </div>
            <Button
              size='sm'
              variant='danger'
              onClick={() => handleUpdateApp(onLoading)}
              disabled={loading}
            >
              {loading && <Spinner animation='border' size='sm' className='me-1' />}
              Update
            </Button>
          </div>

          <div className='mb-2'>
            <span className='fs-5 fw-semibold'>Integrations</span>
            <small className='text-muted d-block mb-3' style={{fontSize: '11px'}}>
              Enhance Workflows with Advanced Tools
            </small>
            <NavbarIntegrationsSection onClose={onClose} />
          </div>
        </Offcanvas.Body>
      </Offcanvas>

      <ModalSearchMovile isOpen={isOpenSearch} onClose={onCloseSearch} />
      {isOpenAddQuote && <ModalAddQuickQuote isOpen={isOpenAddQuote} onClose={onCloseAddQuote} />}
      <SystemMonitorDrawer isOpen={isOpenMonitor} onClose={onCloseMonitor} />
    </div>
  )
}

export {Navbar}
